













































import config from 'config'
import Vue, { PropType } from 'vue'
import Calculator from './Calculator.vue'
import ProgressiveLoader from './ProgressiveLoader.vue'
import Observer from './Observer/Observer.vue'
import BaseFigure from './BaseFigure.vue'
import IBox, { BoxBtn } from './interfaces/IBox'
import extractImageData from './utils/extractImageData'

export default Vue.extend({
	name: 'Box',
	props: {
		box: {
			type: Object as PropType<IBox>,
			required: true
		},
		categoryProps: {
			type: String,
			default: config.rootcategories.drukowanie
		}
	},
	components: {
		"Observer": Observer,
		ProgressiveLoader,
		Calculator,
		BaseFigure
	},
	data: () => ({ extractImageData, intersected: false, config }),
	computed: {
		classes(): string[] {
			const { type, image, imageAlign } = this.box
			return ['box', `box--${type}`, image && imageAlign ? `box--image-${imageAlign}` : '']
		},
		boxBackground(): string {
			if (this.intersected && this.box.background && this.box.background.url) {
				return `url(${this.box.background.url})`
			}
			return ''
		}
	},
	methods: {
		showButton(btn: BoxBtn): boolean {
			return Object.values(btn).every((val) => val)
		},
		isExternalLink(link: string){
			return link.startsWith("http");
		}
	}
})
